import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SaladIcon, EyeIcon, WindIcon, SparklesIcon } from 'lucide-react';
export function FivePillars() {
  return <section className="w-full bg-warm-dark py-20 md:py-28 relative overflow-hidden" data-id="element-46">
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-sunset/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-47" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-49">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-6" data-id="element-50">
            ¿Por qué otros métodos{' '}
            <span className="text-amber italic" data-id="element-51">fallan?</span>
          </h2>
          <p className="font-body text-cream-muted/75 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-52">
            Porque se enfocan solo en la motivación pasajera, sin darte un plan
            integral. Este libro combina cinco pilares:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="group bg-warm-dark-alt border border-warm-border rounded-2xl p-6 text-center" data-id="element-54">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber/10 border border-amber/20 mb-4" data-id="element-55">
              <MoonIcon className="w-5 h-5 text-amber" data-id="element-56" />
            </div>
            <h3 className="font-display text-lg font-semibold text-cream mb-2" data-id="element-57">
              Descanso Reparador
            </h3>
            <p className="font-body text-cream-muted/65 text-sm leading-relaxed" data-id="element-58">
              Rutinas efectivas para un sueño restaurador
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="group bg-warm-dark-alt border border-warm-border rounded-2xl p-6 text-center" data-id="element-59">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber/10 border border-amber/20 mb-4" data-id="element-60">
              <SaladIcon className="w-5 h-5 text-amber" data-id="element-61" />
            </div>
            <h3 className="font-display text-lg font-semibold text-cream mb-2" data-id="element-62">
              Nutrición Consciente
            </h3>
            <p className="font-body text-cream-muted/65 text-sm leading-relaxed" data-id="element-63">
              Revitaliza cuerpo y mente con lo que comes
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="group bg-warm-dark-alt border border-warm-border rounded-2xl p-6 text-center" data-id="element-64">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber/10 border border-amber/20 mb-4" data-id="element-65">
              <EyeIcon className="w-5 h-5 text-amber" data-id="element-66" />
            </div>
            <h3 className="font-display text-lg font-semibold text-cream mb-2" data-id="element-67">
              Visualización
            </h3>
            <p className="font-body text-cream-muted/65 text-sm leading-relaxed" data-id="element-68">
              Descubre oportunidades visualizando tus metas
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="group bg-warm-dark-alt border border-warm-border rounded-2xl p-6 text-center" data-id="element-69">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber/10 border border-amber/20 mb-4" data-id="element-70">
              <WindIcon className="w-5 h-5 text-amber" data-id="element-71" />
            </div>
            <h3 className="font-display text-lg font-semibold text-cream mb-2" data-id="element-72">
              Respiración
            </h3>
            <p className="font-body text-cream-muted/65 text-sm leading-relaxed" data-id="element-73">
              Ejercicios para calmar la ansiedad al instante
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="group bg-warm-dark-alt border border-warm-border rounded-2xl p-6 text-center" data-id="element-74">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber/10 border border-amber/20 mb-4" data-id="element-75">
              <SparklesIcon className="w-5 h-5 text-amber" data-id="element-76" />
            </div>
            <h3 className="font-display text-lg font-semibold text-cream mb-2" data-id="element-77">
              Nuevas Habilidades
            </h3>
            <p className="font-body text-cream-muted/65 text-sm leading-relaxed" data-id="element-78">
              Refuerza tu confianza con aprendizaje continuo
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}